'use strict';

angular.module('atex.dam').factory('DamPartitionsService', ['DamService', '$q',
function(DamService, $q) {
  var partitions = [];
  var templates = [];
  var configured = [];

  return {
    loadPartitions: function () {
      var deferred = $q.defer();
      if (partitions.length > 0) {
        deferred.resolve(partitions);
      } else {
        DamService.getPartitions().then(function (result) {
          if ((result !== undefined) && (result.data.aspects.contentData.data.partitions.length > 0)) {
            var objs = result.data.aspects.contentData.data.partitions;
            objs.forEach(function (obj) {
              obj.templates.forEach(function (template) {
                var partition = {};
                partition.icon = obj.icon;
                partition.color = obj.color;
                partition.partition = obj.partition;

                partitions[template] = partition;
                templates[obj.partition] = partition;
              });

              configured[obj.partition] = {"id": obj.partition, "icon": obj.icon, "label": obj.label};
            });
          }
          deferred.resolve(partitions);
        }).then(null, function (error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },

    getPartitions: function () {
      return partitions;
    },

    getTemplates: function () {
      return templates;
    },

    getAllPartitions: function () {
      return configured;
    }
  };
}]);